export default [
    {
        title: 'Advanced Custom Field',
        logo:
            'https://cdn.shopify.com/s/files/applications/107b81424b64a210842c3f6f4f4fe850_200x200.png?1574062116',
        url: 'https://apps.shopify.com/advanced-custom-field#modal-show=AuthModal',
        plan: 'Free',
        subtitle: 'Custom Fields / Metafields Editor / Add Metafields on demand',
        rate: 5,
    },
    {
        title: 'Native Translate',
        logo:
            'https://cdn.shopify.com/s/files/1/0470/1503/5036/t/13/assets/native.png?v=1620707142',
        url: 'https://apps.shopify.com/atranslate-multilingual#modal-show=AuthModal',
        plan: 'Free',
        subtitle: 'Translate your store into multi languages',
        rate: 5,
    },
    {
        title: 'YouTube Video Gallery',
        logo:
            'https://cdn.shopify.com/s/files/1/0470/1503/5036/t/13/assets/youtube.png?v=1620707215',
        url: 'https://apps.shopify.com/youtube-feed-by-arena#modal-show=AuthModal',
        plan: 'Free',
        subtitle: 'Display completely customizable YouTube feeds on your website',
        rate: 5,
    },
];
